// 资源配置文件
// 这里统一管理所有静态资源的路径，方便后续切换到OSS/CDN

// 基础URL - 本地开发时使用相对路径，生产环境使用OSS/CDN地址
export const BASE_URL = 'https://info-yunjinghb.oss-cn-beijing.aliyuncs.com';

// 首页轮播图
export const CAROUSEL_IMAGES = {
  AIR_HEATER_1: `${BASE_URL}/static/首页轮播图/风暖炉首页轮播图1.png`,
  AIR_HEATER_2: `${BASE_URL}/static/首页轮播图/风暖炉首页轮播图2.png`,
  WATER_HEATER_1: `${BASE_URL}/static/首页轮播图/水暖炉首页轮播图1.png`,
};

// 资质专利
export const QUALIFICATION_IMAGES = {
  QUALIFICATION: `${BASE_URL}/static/资质拼凑.png`,
  PATENT_1: `${BASE_URL}/static/资质专利/1.png`,
  PATENT_2: `${BASE_URL}/static/资质专利/2.jpg`,
  PATENT_3: `${BASE_URL}/static/资质专利/3.png`,
  PATENT_4: `${BASE_URL}/static/资质专利/4.png`,
  PATENT_5: `${BASE_URL}/static/资质专利/5.png`,
  PATENT_6: `${BASE_URL}/static/资质专利/6.png`,
  PATENT_7: `${BASE_URL}/static/资质专利/7.png`,
  PATENT_8: `${BASE_URL}/static/资质专利/8.png`,
  PATENT_9: `${BASE_URL}/static/资质专利/9.png`,
  PATENT_10: `${BASE_URL}/static/资质专利/10.png`,
  PATENT_11: `${BASE_URL}/static/资质专利/11.png`,
  PATENT_12: `${BASE_URL}/static/资质专利/12.png`,
  PATENT_13: `${BASE_URL}/static/资质专利/13.png`,
  PATENT_14: `${BASE_URL}/static/资质专利/14.jpg`,
};

// 风暖颗粒炉型号
export const AIR_GRANULE_MODELS = {
  SMART_60: `${BASE_URL}/static/风暖颗粒炉型号/智能款60.jpg`,
  SMART_80: `${BASE_URL}/static/风暖颗粒炉型号/智能款80.jpg`,
  SMART_100: `${BASE_URL}/static/风暖颗粒炉型号/智能款100.jpg`,
  SMART_120: `${BASE_URL}/static/风暖颗粒炉型号/智能款120.jpg`,
  SMART_160: `${BASE_URL}/static/风暖颗粒炉型号/智能款160.jpg`,
  SMART_200: `${BASE_URL}/static/风暖颗粒炉型号/智能款200.jpg`,
  SMART_260: `${BASE_URL}/static/风暖颗粒炉型号/智能款260.jpg`,
};

// 水暖颗粒炉型号
export const WATER_GRANULE_MODELS = {
  YCS_80: `${BASE_URL}/static/水暖颗粒炉型号/YCS-80.jpg`,
  YCS_120A: `${BASE_URL}/static/水暖颗粒炉型号/YCS-120A.jpg`,
  YCS_120B: `${BASE_URL}/static/水暖颗粒炉型号/YCS-120B.jpg`,
  YCS_150: `${BASE_URL}/static/水暖颗粒炉型号/YCS-150.jpg`,
  YS_200: `${BASE_URL}/static/水暖颗粒炉型号/YS-200.jpg`,
  YS_300: `${BASE_URL}/static/水暖颗粒炉型号/YS-300.jpg`,
  YS_400: `${BASE_URL}/static/水暖颗粒炉型号/YS-400.jpg`,
  YS_500: `${BASE_URL}/static/水暖颗粒炉型号/YS-500.jpg`,
};

// 燃木壁炉型号
export const WOOD_FIREPLACE_MODELS = {
  MODEL_50: `${BASE_URL}/static/燃木壁炉型号/50.jpg`,
  MODEL_57: `${BASE_URL}/static/燃木壁炉型号/57.jpg`,
  MODEL_60: `${BASE_URL}/static/燃木壁炉型号/60一体.jpg`,
  MODEL_66: `${BASE_URL}/static/燃木壁炉型号/66.jpg`,
  MODEL_70: `${BASE_URL}/static/燃木壁炉型号/70一体.jpg`,
  MODEL_75: `${BASE_URL}/static/燃木壁炉型号/75.jpg`,
  MODEL_80: `${BASE_URL}/static/燃木壁炉型号/80一体.jpg`,
  MODEL_88: `${BASE_URL}/static/燃木壁炉型号/88.jpg`,
  MODEL_102: `${BASE_URL}/static/燃木壁炉型号/102.jpg`,
  MODEL_112: `${BASE_URL}/static/燃木壁炉型号/112组合.jpg`,
  MODEL_122: `${BASE_URL}/static/燃木壁炉型号/122组合.jpg`,
};

// 使用说明书图片
export const MANUAL_IMAGES = {
  AIR_HEATER: `${BASE_URL}/static/风暖炉使用说明书/风暖炉图.png`,
  AIR_HEATER_STRUCTURE: `${BASE_URL}/static/风暖炉使用说明书/风暖炉结构图.png`,
  WATER_HEATER: `${BASE_URL}/static/水暖炉使用说明书/水暖炉图.png`,
  WATER_HEATER_STRUCTURE: `${BASE_URL}/static/水暖炉使用说明书/水暖炉结构图.png`,
  WOOD_FIREPLACE: `${BASE_URL}/static/燃木壁炉使用说明书/燃木壁炉图.png`,
  WOOD_FIREPLACE_INSTALL: `${BASE_URL}/static/燃木壁炉使用说明书/燃木壁炉安装图.png`,
  BURNER: `${BASE_URL}/static/燃烧机使用说明书/燃烧机图.png`,
  BURNER_STRUCTURE: `${BASE_URL}/static/燃烧机使用说明书/燃烧机结构图.png`,
};

// 视频资源
export const VIDEOS = {
  AIR_HEATER_INSTALL: `${BASE_URL}/static/风暖炉使用说明书/风暖炉安装教程.mp4`,
  AIR_HEATER_CLEAN: `${BASE_URL}/static/风暖炉操作/风暖炉清灰教程.mp4`,
  AIR_HEATER_REPAIR: `${BASE_URL}/static/风暖炉维修/风暖炉更换排烟风机.mp4`,
  WATER_HEATER_INSTALL: `${BASE_URL}/static/水暖炉使用说明书/水炉200-500安装使用.mp4`,
  WATER_HEATER_CLEAN: `${BASE_URL}/static/水暖炉操作/水炉200-500清灰教程.mp4`,
  BURNER_IGNITION: `${BASE_URL}/static/燃烧机使用说明书/手动燃烧机点火演示.mp4`,
};

// 其他图片
export const OTHER_IMAGES = {
  WECHAT_ICON: `${BASE_URL}/static/微信图标.png`,
  AIR_HEATER_BACKGROUND: `${BASE_URL}/static/风暖炉背景图.png`,
  WATER_HEATER_BACKGROUND: `${BASE_URL}/static/水暖炉背景图.png`,
  WOOD_FIREPLACE_BACKGROUND: `${BASE_URL}/static/燃木壁炉背景图.png`,
  BURNER_BACKGROUND: `${BASE_URL}/static/燃烧机背景图.png`,
  CERTIFICATION: `${BASE_URL}/static/认证资质.jpg`,
  LAYER_1: `${BASE_URL}/static/图层 1.jpg`,
};
